import React, { createContext, useState, useEffect } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "../services/firebase";

export const TenantContext = createContext({
    idTenant: null,
    tenantName: null,
    tenantSlug: null,
    tenantLogo: null,
    claims: null,
    user: null,
    loading: true
});

export const TenantProvider = ({ children }) => {
    const [idTenant, setIdTenant] = useState(null);
    const [tenantName, setTenantName] = useState(null);
    const [tenantSlug, setTenantSlug] = useState(null);
    const [tenantLogo, setTenantLogo] = useState(null);
    const [claims, setClaims] = useState(null);
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Observe auth state changes locally to re-fetch claims and profile
        // Alternatively, we could hook into AuthContext, but hooking into onAuthStateChanged
        // directly here is often more robust for Firebase timing on ID tokens.
        const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
            if (firebaseUser) {
                try {
                    const tokenResult = await firebaseUser.getIdTokenResult();
                    const customClaims = tokenResult.claims;

                    const role = customClaims.role || null;
                    const tenant = customClaims.idTenant || null;
                    const permissions = customClaims.permissions || {};

                    // Buscando perfil global do usuário no Firestore
                    const userDoc = await getDoc(doc(db, "users", firebaseUser.uid));
                    const profileData = userDoc.exists() ? userDoc.data() : {};

                    let tName = null;
                    let tSlug = null;
                    let tLogo = null;
                    if (tenant) {
                        const tenantDoc = await getDoc(doc(db, "tenants", tenant));
                        if (tenantDoc.exists()) {
                            tName = tenantDoc.data().name || null;
                            tSlug = tenantDoc.data().slug || null;
                            tLogo = tenantDoc.data().logoUrl || null;
                        }
                    }

                    setIdTenant(tenant);
                    setTenantName(tName);
                    setTenantSlug(tSlug);
                    setTenantLogo(tLogo);
                    setClaims({
                        role,
                        idTenant: tenant,
                        permissions
                    });

                    const loggedUser = {
                        uid: firebaseUser.uid,
                        email: firebaseUser.email,
                        fullName: profileData.fullName || profileData.name || null,
                        displayName: profileData.fullName || profileData.name || firebaseUser.displayName || firebaseUser.email,
                        photoURL: profileData.photoUrl || profileData.photoURL || profileData.avatar || firebaseUser.photoURL,
                        role: role
                    };
                    
                    setUser(loggedUser);


                } catch (error) {
                    console.error("Erro ao processar dados de Tenant:", error);
                }
            } else {
                setIdTenant(null);
                setTenantName(null);
                setTenantSlug(null);
                setTenantLogo(null);
                setClaims(null);
                setUser(null);
            }
            setLoading(false);
        });

        return () => unsubscribe();
    }, []);

    const value = {
        idTenant,
        tenantName,
        tenantSlug,
        tenantLogo,
        claims,
        user,
        loading
    };

    return (
        <TenantContext.Provider value={value}>
            {children}
        </TenantContext.Provider>
    );
};
